module.exports = __webpack_public_path__ + "img/header3.89ae24b6.png";